export interface YearlyCostBreakdown {
  serviceFees: number[];
  implementationCosts: number[];
  integrationCosts: number[];
  otherCosts: number[];
  total: number[];
}

export interface CostMetric {
  labelKey: string;
  tooltipKey: string;
  type: 'currency' | 'percentage' | 'hours';
  value: number;
  icon: string;
  iconAccent: 'cyan' | 'green' | 'violet' | 'amber' | 'red';
}

export interface DetailedBreakdownRow {
  labelKey: string;
  values: number[];
  total: number;
}

export interface CombinedDetailedBreakdownRow {
  id: string;
  providerName: string;
  providerColor: string;
  currencyLocale: string;
  currencyCode: string;
  isFirstProviderRow: boolean;
  labelKey: string;
  values: number[];
  total: number;
  isTotalRow: boolean;
}

export interface ProviderCostComparisonVm {
  hrToolDirectusId: string;
  translatedName: string;
  totalCost: number;
  currencyLocale: string;
  currencyCode: string;
  years: number[];
  yearLabels: string[];
  metrics: CostMetric[];
  yearlyBreakdown: YearlyCostBreakdown;
  detailedRows: DetailedBreakdownRow[];
}

export interface CostChartLegendItem {
  providerName: string;
  color: string;
}

export type CostDevelopmentChartView = 'years' | 'total';

export type CostType = 'serviceFees' | 'implementationCosts' | 'integrationCosts' | 'otherCosts';
export const ALL_COST_TYPES: CostType[] = [
  'serviceFees',
  'implementationCosts',
  'integrationCosts',
  'otherCosts',
];
